import React, { useState } from "react";

const WhatsAppWidget = () => {
  const [open, setOpen] = useState(false);
  const whatsappLink = "https://wa.me/1234567890"; // Replace with your WhatsApp number

  const [currentPage, setCurrentPage] = useState("withdrawal");

  const updateCurrentPage = () => {
    const currentPath = window.location.pathname;
    console.log(currentPath);

    if (currentPath.includes("withdrawal")) {
      setCurrentPage("withdrawal");
      setOpen(true);
    } else if (currentPath.includes("deposit")) {
      setCurrentPage("deposit");
      setOpen(true);
    } else {
      setCurrentPage("other");
      setOpen(true);
    }
  };

  const qrCodes = {
    withdrawal:
      "https://zedlytics.s3.me-central-1.amazonaws.com/MT+withdrawal+QR+Code.png",
    deposit:
      "https://zedlytics.s3.me-central-1.amazonaws.com/MT+Deposit+QR+Code.png",
    other:
      "https://zedlytics.s3.me-central-1.amazonaws.com/MT+Support+QR+Code.png",
  };

  const whatsappLinks = {
    withdrawal:
      "https://wa.me/919833251795?text=Hi%2C%20I%20am%20facing%20issue%20in%20my%20withdrawal%2C%20please%20help%20me%20getting%20my%20withdrawal",
    deposit:
      "https://wa.me/919594033509?text=Hi%2C%20I%20am%20facing%20an%20issue%20with%20deposit%2C%20Please%20help%20me%20getting%20my%20deposit%20done.",
    other:
      "https://wa.me/918692913616?text=Hi%2C%20I%20am%20facing%20issue%2C%20I%20need%20Support",
  };

  const whatsappText = {
    withdrawal:
      "Scan the QR code or click below to contact support if you're experiencing issues with your withdrawal.",
    deposit:
      "Scan the QR code or click below to contact support if you're experiencing issues with your deposit.",
    other: "Scan the QR code.",
  };

  return (
    <div>
      {/* Floating Button */}
      <div
        className="position-fixed bottom-0 end-0 m-4 d-flex justify-content-center align-items-center rounded-circle bg-success text-light shadow cursor-pointer"
        style={{ width: "50px", height: "50px", zIndex: 1050, cursor: "pointer" }}
        onClick={() => updateCurrentPage()}
      >
        <i className="fab fa-whatsapp fs-2" aria-hidden="true"></i>
      </div>

      {/* Chatbox Window */}
      {open && (
        <div
          className="position-fixed end-0 m-3 bg-white shadow rounded p-2 bottom-custom"
          style={{ width: "300px", zIndex: 1051 }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="m-0">Chat Support</h6>
            <button
              className="btn btn-close"
              onClick={() => setOpen(!open)}
            ></button>
          </div>
          <hr />
          <div className="text-center">
            <div className="row mt-4 mb-2">
              <div className="col-12 text-center">
                <strong>{whatsappText[currentPage]}</strong>
              </div>

              <div className="col-12 text-center mt-3">
                <img src={qrCodes[currentPage]} alt="MT QR Code" />
              </div>

              <div className="col-12 text-center mt-3">
                <a
                  href={whatsappLinks[currentPage]}
                  className="btn text-successbtn btn-outline-primary"
                  target="_blank"
                >
                  Or Click Here for WhatsApp support
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppWidget;
